/**
 * Command suggestions for the stdio form; any command is accepted since the
 * server runs inside an isolated per-session sandbox.
 */
export const SUGGESTED_STDIO_COMMANDS = ["uvx", "npx", "pnpx", "bash"] as const;

/** Max length for an MCP server display name; mirrors backend validation. */
export const MCP_DISPLAY_NAME_MAX_LENGTH = 64;
